import { siblings } from "../Utils";

/* Helper function for toggling hidden class in ManagementTeamBlock */
export function registerReadMore(): void {
    // find all elements with data-* tag for ReadMoreContent
    const $displayContent = document.querySelectorAll('[data-read-more-content]');
    if (!$displayContent?.length) return;

    $displayContent.forEach(($showContent) => {
        const contentID = $showContent.getAttribute('data-read-more-content');

        // Check if value is set (is neither null or empty)
        if (!contentID?.length) return;

        // on click => toggle hidden class for data-read-more-content element with class name data-read-more-content
        $showContent.addEventListener('click', () => {
            console.log("clicked on:", $displayContent)
            let $siblings = siblings($showContent);
            let $showContentList = $siblings[0];
            if ($showContentList) {
                $showContentList.classList.toggle('hidden');
            }
        });
    });
}
